import styled from 'styled-components';

export const StyledLoadingContainer = styled.div`
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
